import Model from 'flarum/common/Model';
export default class Block extends Model {
  name() {
    return Model.attribute('name').call(this);
  }
  description() {
    return Model.attribute('description').call(this);
  }
  color() {
    return Model.attribute('color').call(this);
  }
  icon() {
    return Model.attribute('icon').call(this);
  }
  position() {
    return Model.attribute('position').call(this);
  }
  isHidden() {
    return Model.attribute('isHidden').call(this);
  }
  forums() {
    return Model.hasMany('forums').call(this);
  }
}
flarum.reg.add('neverhack-forum-nodes', 'common/models/Block', Block);